/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ContentContainer } from '@/components/ContentContainer';
import { QueryWrapper } from '@/components/QueryWrapper';
import { usePaginatedJobsQuery } from '@/hooks/query/usePaginatedJobsQuery';
import { JobListTable } from '@/pages/Jobs/JobListTable';
import { JobsHeader } from '@/pages/Jobs/JobsHeader';
import { Container } from '@/primitives/Container';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export function JobsPage() {
  const tenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  const jobsQuery = usePaginatedJobsQuery({
    type: 'queryParams',
  });

  if (!tenantID) return null;
  return (
    <ContentContainer width="100%">
      <Container full style={{ width: '100%' }}>
        <JobsHeader />
        <QueryWrapper queryResult={jobsQuery}>
          {(jobsData) => (
            <JobListTable
              tenantID={tenantID}
              jobsData={jobsData}
              updateQueryParams={jobsQuery.updateQueryParams}
              jobFilters={jobsQuery.filters}
            />
          )}
        </QueryWrapper>
      </Container>
    </ContentContainer>
  );
}
